import { Alternativa } from 'src/app/Models/alternativa.model';
import { Resposta } from 'src/app/Models/resposta.model';

export class Pergunta {
    perguntaid: number;
    descricao: string;
    areaparticipacaoid: number;
    enquenteid: number;
    multiplaescolha: boolean;
    alternativa: Alternativa[];
    resposta: Resposta;
}